import { forwardRef, type Ref, type SVGProps } from "react";
const IconTreesEvergreenOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M21.78 2.988a1.5 1.5 0 0 1 2.44 0l4.03 5.64c.708.993-.002 2.372-1.221 2.372h-.16l2.445 3.668c.664.997-.05 2.332-1.248 2.332h-.448l1.915 3.83A1.5 1.5 0 0 1 28.19 23H24v5h5a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h5v-2H3.81a1.5 1.5 0 0 1-1.343-2.17l1.951-3.902a1.502 1.502 0 0 1-.821-2.2l1.716-2.86c-.798-.36-1.166-1.392-.627-2.2l3.066-4.599a1.5 1.5 0 0 1 2.496 0l3.066 4.599c.539.808.17 1.84-.627 2.2l1.716 2.86a1.502 1.502 0 0 1-.82 2.2l1.95 3.901A1.5 1.5 0 0 1 14.19 26H10v2h12v-5h-4.19a1.5 1.5 0 0 1-1.343-2.17L18.382 17h-.448c-1.198 0-1.912-1.335-1.248-2.332L19.131 11h-.16c-1.22 0-1.93-1.38-1.22-2.372l4.028-5.64zM27.381 21H24v-2a1 1 0 1 0-2 0v2h-3.382l1.915-3.83A1.5 1.5 0 0 0 19.19 15h-.322l2.445-3.668c.664-.997-.05-2.332-1.248-2.332h-.123L23 4.72 26.057 9h-.123c-1.198 0-1.912 1.335-1.248 2.332L27.131 15h-.322a1.5 1.5 0 0 0-1.342 2.17L27.382 21zM10 22v2h3.382l-1.915-3.83a1.5 1.5 0 0 1 .822-2.079l-1.692-2.82a1.5 1.5 0 0 1 .633-2.124L9 9.803l-2.23 3.344c.753.363 1.11 1.33.633 2.125l-1.692 2.82a1.5 1.5 0 0 1 .822 2.079L4.618 24H8v-2a1 1 0 1 1 2 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTreesEvergreenOutlineSVG);
ForwardRef.displayName = "IconTreesEvergreenOutline";
export { ForwardRef as IconTreesEvergreenOutline };
